import { CPF_INVOICE_KEY_NAME } from "../constants/keyNamesSessionStorage";
import { escOnlyNumbersHelper } from "./escOnlyNumbersHelper";

export const getCpfInvoiceHelper = () => {
  const cpf = sessionStorage.getItem(CPF_INVOICE_KEY_NAME) || "";

  return escOnlyNumbersHelper(cpf);
};
